var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.76232 0.0368959C5.93257 0.109376 6.04307 0.27652 6.04307 0.461549V4.76812H8.46152C8.62565 4.76812 8.77743 4.85528 8.86015 4.99704C8.94287 5.13879 8.94409 5.31381 8.86335 5.45671L8.56054 5.99262C7.41216 8.02501 5.94762 9.86168 4.22189 11.4337L3.73234 11.8797C3.59723 12.0027 3.40221 12.0345 3.23503 11.9606C3.06785 11.8868 2.96 11.7212 2.96 11.5385V7.26839H0.461538C0.206637 7.26839 0 7.06176 0 6.80686C0 6.7243 0.0216771 6.6468 0.0596503 6.57975C1.14198 4.57886 2.52769 2.75765 4.16751 1.1809L5.26163 0.128858C5.39501 0.000612423 5.59208 -0.0355839 5.76232 0.0368959ZM1.25205 6.34532H3.42153C3.67643 6.34532 3.88307 6.55196 3.88307 6.80686V10.4889C5.37144 9.08243 6.64718 7.46625 7.66978 5.69119H5.58153C5.32663 5.69119 5.11999 5.48456 5.11999 5.22966V1.54562L4.8073 1.84628C3.42221 3.1781 2.22634 4.69195 1.25205 6.34532Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoin);
export default __webpack_public_path__ + "static/media/join.4674afa9e34c6399eb108d59fb05d486.svg";
export { ForwardRef as ReactComponent };